import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

import { noop } from '@src/utils';
import React from 'react';

interface FormProps {
  children?: React.ReactNode;
  onSubmit?: () => void;
  sx?: SxProps<Theme>;
}

const Form = React.forwardRef<HTMLFormElement, FormProps>(
  ({ children, onSubmit = noop, sx }, ref) => {
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      e.stopPropagation();
      onSubmit();
    };

    return (
      <Box ref={ref} sx={sx} component="form" onSubmit={handleSubmit}>
        {children}
      </Box>
    );
  },
);

Form.displayName = 'Form';
export default Form;
